import styled from '@emotion/styled';

export const Tag = styled.span`
  padding: 4px;
  border-radius: 3px;

  width: fit-content;
  height: fit-content;

  font-size: var(--font-size-small);
  text-transform: lowercase;
`;
